var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "hamburger",
      class: { "is-active": _vm.isActive },
      attrs: {
        type: "button",
        "aria-expanded": _vm.isActive ? "true" : "false",
      },
      on: { click: _vm.toggleClick },
    },
    [
      _c("lucide-icon", {
        attrs: {
          icon: _vm.isActive
            ? _vm.icons.panelLeftClose
            : _vm.icons.panelLeftOpen,
          size: 20,
          "aria-hidden": "true",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }